module.exports = __webpack_public_path__ + "static/media/ThreeDots.bc78fa65.svg";